module.exports = __webpack_public_path__ + "assets/arrowBlack.f17ade00.svg";